<div class="shop-view-filter">
  <shop-view-filter-menu (change)="doChange()" *ngFor="let f of view.filters" [filter]="f"
                         [filtercomp]="this"></shop-view-filter-menu>
</div>
